import ComingSoon from './ComingSoon';

export default function SettingsPage() {
  return (
    <ComingSoon
      title="Settings"
      fallbackHref="/settings"
      description="Settings (Backup & Restore, LLM configuration, License Manager accounts) are still served by the classic UI."
    />
  );
}
